import React from "react";
import { createMongoProxy } from "./mongoProxy";

const mongoProxy = createMongoProxy();

export function createRealmApp() {
  return mongoProxy;
}

const RealmAppContext = React.createContext(null);

export function RealmAppProvider({ children }) {
  return (
    <RealmAppContext.Provider value={mongoProxy}>
      {children}
    </RealmAppContext.Provider>
  );
}

export function useRealmApp() {
  const app = React.useContext(RealmAppContext);
  if (!app) {
    throw new Error(
      `No App found. Make sure to call useRealmApp() inside of a <RealmAppProvider />.`
    );
  }
  return app;
}
